module.exports = __webpack_public_path__ + "wilshire.4e21f01e2f5da08a686821cc01621425.svg";